/*!

=========================================================
* Auscomp Cloud Services - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";

// import { Router, Route, Switch } from "react-router";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "assets/scss/material-kit-pro-react.scss?v=1.9.0";

// pages for this product
import AboutUsPage from "views/AboutUsPage/AboutUsPage.js";
import BlogPostPage from "views/BlogPostPage/BlogPostPage.js";
import BlogPostsPage from "views/BlogPostsPage/BlogPostsPage.js";
import ComponentsPage from "views/ComponentsPage/ComponentsPage.js";
import ContactUsPage from "views/ContactUsPage/ContactUsPage.js";
import EcommercePage from "views/EcommercePage/EcommercePage.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import LoginPage from "views/LoginPage/LoginPage.js";
import LoginQRCodePage from "views/LoginQRCodePage/LoginQRCodePage.js";
import LoginMFAPage from "views/LoginMFAPage/LoginMFAPage.js";
import ResetPassword from "views/ResetPassword/ResetPassword.js";
import ForgotPasswordPage from "views/ForgotPasswordPage/ForgotPasswordPage.js";
import SetQuestionPage from "views/SetQuestionPage/SetQuestionPage.js";

import HomePage from "views/HomePage/SectionsPage.js";
import DashboardPage from "views/DashboardPage/SectionsPage.js";
import CSPDashboardPage from "views/CSPDashboardPage/SectionsPage.js";
import SubscriptionChangeReportPage from "views/CSPDashboardPage/SubscriptionChangeReportPage.js";
import UsersPage from "./views/CSPDashboardPage/UsersPage.js";
import SubscriptionUpgrade from "./views/CSPDashboardPage/SubscriptionUpgrade.js";
import AddUserPage from "./views/CSPDashboardPage/AddUserPage.js";
import EditUserPage from "./views/CSPDashboardPage/EditUserPage.js";
import AccountPage from "views/CSPDashboardPage/AccountPage.js";
import Internal from "views/CSPDashboardPage/Internal.js";
import PricingPage from "views/PricingPage/PricingPage.js";
import ProfilePage from "views/ProfilePage/ProfilePage.js";
import ProductPage from "views/ProductPage/ProductPage.js";
import SectionsPage from "views/SectionsPage/SectionsPage.js";
import ManualOrderPage from "views/ManualOrderPage/ManualOrderPage.js";
import ManualOrderPageKinetix from "views/ManualOrderPageKinetix/ManualOrderPage.js";
import ShoppingCartPage from "views/ShoppingCartPage/ShoppingCartPage.js";
import SignupPage from "views/SignupPage/SignupPage.js";
import ErrorPage from "views/ErrorPage/ErrorPage.js";
import { ToastContainer, Zoom } from "react-toastify";
import ProtectedRoute from "../src/redux/auth/ProtectedRoute";

import "react-toastify/dist/ReactToastify.css";
import "tailwind.generated.css"; // Adjust path as needed
import { Provider } from "react-redux";
import store from "../src/redux/configureStore";

ReactDOM.render(
	<>
		<Provider store={store}>
			<Router>
				<Routes>
					<Route path="/about-us" element={<AboutUsPage />} />
					<Route path="/blog-post" element={<BlogPostPage />} />
					<Route path="/blog-posts" element={<BlogPostsPage />} />
					<Route path="/components" element={<ComponentsPage />} />
					<Route path="/contact-us" element={<ContactUsPage />} />
					<Route path="/ecommerce-page" element={<EcommercePage />} />
					<Route path="/landing-page" element={<LandingPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/pricing" element={<PricingPage />} />
					<Route path="/profile-page" element={<ProfilePage />} />
					<Route path="/product-page" element={<ProductPage />} />
					<Route path="/sections" element={<SectionsPage />} />
					<Route path="/manual-order" element={<ManualOrderPage />} />
					<Route path="/manual-order-kinetix" element={<ManualOrderPageKinetix />} />
					<Route path="/shopping-cart-page" element={<ShoppingCartPage />} />
					<Route path="/signup-page" element={<SignupPage />} />
					<Route path="/error-page" element={<ErrorPage />} />
					<Route path="/login-qr-code" element={<LoginQRCodePage />} />
					<Route path="/login-set-question" element={<SetQuestionPage />} />
					<Route path="/login-mfa" element={<LoginMFAPage />} />
					<Route path="/forgot-password" element={<ForgotPasswordPage />} />
					<Route path="/internal" element={<Internal />} />
					<Route path="/reset-password" element={<ResetPassword />} />
					<Route element={<ProtectedRoute />}>
						<Route path="/dashboard" element={<DashboardPage />} />
						<Route path="/csp-dashboard" element={<AccountPage />} />
						<Route path="/account" element={<CSPDashboardPage />} />
						<Route path="/upgrade-subscription" element={<SubscriptionUpgrade />} />
						<Route path="/users" element={<UsersPage />} />
						<Route path="/add-user" element={<AddUserPage />} />
						<Route path="/user/:id/edit" element={<EditUserPage />} />
						<Route
							path="/subscription-change-report"
							element={<SubscriptionChangeReportPage />}
						/>
					</Route>
					<Route path="/" element={<HomePage />} />
					<Route path="/404" element={<ErrorPage />} />
					{/* Redirect all unmatched routes to the 404 page */}
					<Route path="*" element={<ErrorPage />} />
				</Routes>
			</Router>

			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				transition={Zoom}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				style={{
					marginTop: "125px",
					marginRight: "-10px",
					borderRadius: "0",
				}}
				pauseOnHover
				limit={1}
			/>
		</Provider>
	</>,
	document.getElementById("root")
);
